var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "vgt-global-search vgt-clearfix" }, [
      _c("div", { staticClass: "vgt-global-search__input vgt-pull-left" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.search,
              expression: "search"
            }
          ],
          staticClass: "vgt-input vgt-pull-left",
          attrs: { type: "text", placeholder: _vm.$t("txtSearch") },
          domProps: { value: _vm.search },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.search = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vgt-global-search__actions vgt-pull-right" })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "scrollcontainer",
        staticStyle: { "overflow-x": "auto", border: "1px solid #dcdfe6" },
        style: _vm.mixedStyleWOHeight
      },
      [
        _c(
          "div",
          { staticClass: "d-flex flex-row" },
          [
            _c(
              "div",
              {
                staticClass: "osxcol",
                style: { ..._vm.mixedStyleHeight, width: _vm.columnWidth }
              },
              _vm._l(_vm.filteredItems, function(item) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.visible,
                        expression: "item.visible"
                      }
                    ],
                    key: item.id,
                    staticClass: "p-1 px-2 c-pointer osxelement",
                    class: {
                      osxselected: _vm.path.includes(item.id),
                      osxlastselected: _vm.lastSelected === item.id
                    },
                    on: {
                      click: function($event) {
                        return _vm.click($event, item)
                      },
                      dblclick: function($event) {
                        return _vm.$emit("on-double-click", item.item)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.html) +
                        "\n                "
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm._l(_vm.pathElements, function(p) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: p.children.filter(i => i.visible).length > 0,
                      expression: "p.children.filter(i => i.visible).length > 0"
                    }
                  ],
                  key: p.id,
                  staticClass: "osxcol",
                  style: { ..._vm.mixedStyleHeight, width: _vm.columnWidth }
                },
                _vm._l(p.children, function(item) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.visible,
                          expression: "item.visible"
                        }
                      ],
                      key: item.id,
                      staticClass: "p-1 px-2 c-pointer osxelement",
                      class: {
                        osxselected: _vm.path.includes(item.id),
                        osxlastselected: _vm.lastSelected === item.id
                      },
                      on: {
                        click: function($event) {
                          return _vm.click($event, item)
                        },
                        dblclick: function($event) {
                          return _vm.$emit("on-double-click", item.item)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.html) +
                          "\n                "
                      )
                    ]
                  )
                }),
                0
              )
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input__icon" }, [
      _c("div", { staticClass: "magnifying-glass" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }